import NoteBody from './NoteBody';
import HorizontalList from 'components/HorizontalList/HorizontalList';

import { formatDateTime } from 'utilities/datesAndTimes';
import { formatFileName } from 'utilities/helpers';

const { ListItem } = HorizontalList;

const ZendeskInteraction = ({ interaction, highlight }) => {
  return (
    <>
      <HorizontalList>
        <ListItem>{formatDateTime(interaction.timestamp)}</ListItem>
        {interaction.agentName && (
          <ListItem>
            <strong>{interaction.agentName}</strong>
          </ListItem>
        )}
      </HorizontalList>
      <NoteBody
        data-testid="text-interaction-message"
        highlight={highlight}
        searchableContent={interaction.message}
        otherElements={
          interaction.attachments?.length > 0 &&
          interaction.attachments.map((atts, idx) => {
            return (
              <span key={`file-attachment-${idx}`}>
                <a
                  title="Ticket Attachment"
                  key={`file-attachment-${idx}`}
                  data-testid="filename-text"
                  onClick={() =>
                    window.open(
                      atts.contentUrl,
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }
                >
                  {formatFileName(atts.name)}
                </a>
                <br />
              </span>
            );
          })
        }
      />
    </>
  );
};

export default ZendeskInteraction;
